import Vue from 'vue'
import {handleErrors} from "@/services/ErrorHandling";

const self = Vue.prototype

export default {
  getFiltered(query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  create(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminReportsFlight, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  get(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  update(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminReportsFlight + '/update', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminReportsFlight + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  sendToUpost(id) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminReportsFlight + '/upost/' + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getUpostStatusesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + '/upost/statuses-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getConsolidatedInvoice(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/consolidated-invoice/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getConsolidatedInvoicePdf(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/consolidated-invoice/pdf/${id}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBags(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/bags/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getBagsList(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/bag-list/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getBagsListPdf(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/bag-list/pdf/${id}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAvailableBags(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/available-bags/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  createBag(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminReportsFlight + '/add-bags', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  updateBag(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminReportsFlight + '/update-bags', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getPackingList(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/packing-list/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getPackingListPdf(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/packing-list/pdf/${id}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getProfitLoss(id, query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminReportsFlight + `/profit-loss/${id}` + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
}
